module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-navigation-drawer', {
    attrs: {
      "fixed": "",
      "clipped": _vm.$vuetify.breakpoint.mdAndUp,
      "app": ""
    },
    model: {
      value: (_vm.$store.state.mainMenuDrawer),
      callback: function($$v) {
        _vm.$set(_vm.$store.state, "mainMenuDrawer", $$v)
      },
      expression: "$store.state.mainMenuDrawer"
    }
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_vm._l((_vm.items), function(item, i) {
    return _c('div', {
      key: i
    }, [(item.heading) ? _c('v-layout', {
      key: item.heading,
      attrs: {
        "row": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [(item.heading) ? _c('v-subheader', [_vm._v("\n            " + _vm._s(item.heading) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "text-xs-center",
      attrs: {
        "xs6": ""
      }
    }, [_c('a', {
      staticClass: "body-2 black--text",
      attrs: {
        "href": "#!"
      }
    }, [_vm._v("EDIT")])])], 1) : (item.children) ? _c('v-list-group', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.$can('view', item.id)),
        expression: "$can('view', item.id)"
      }],
      key: item.text,
      attrs: {
        "prepend-icon": item.model ? item.iconalt : item.icon,
        "append-icon": ""
      },
      model: {
        value: (item.model),
        callback: function($$v) {
          _vm.$set(item, "model", $$v)
        },
        expression: "item.model"
      }
    }, [_c('v-list-tile', {
      attrs: {
        "slot": "activator"
      },
      slot: "activator"
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n              " + _vm._s(item.text) + "\n            ")])], 1)], 1), _vm._v(" "), _vm._l((item.children), function(child, i) {
      return _c('v-list-tile', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.$can('view', child.id)),
          expression: "$can('view', child.id)"
        }],
        key: i,
        attrs: {
          "to": child.url
        }
      }, [(child.icon) ? _c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(child.icon))])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n              " + _vm._s(child.text) + "\n            ")])], 1)], 1)
    })], 2) : _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.$can('view', item.id)),
        expression: "$can('view', item.id)"
      }],
      key: item.text
    }, [_c('v-list-tile', {
      attrs: {
        "to": item.url,
        "disabled": _vm.isAssignCrewAndTiming(item)
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n              " + _vm._s(item.text) + "\n            ")])], 1)], 1)], 1)], 1)
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61218b11","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppNavigation.vue
// module id = 996
// module chunks = 1